import { render } from "./qr-carton-escaner.vue?vue&type=template&id=1f07c073"
import script from "./qr-carton-escaner.vue?vue&type=script&lang=js"
export * from "./qr-carton-escaner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__